// extracted by mini-css-extract-plugin
module.exports = {"video-container":"VideoBlock_video-container__O4swk","full-width":"VideoBlock_full-width__7MMuk","video":"VideoBlock_video__UWNj_","play-button":"VideoBlock_play-button__saf6o"};